import type { KioskUser } from '@iheartjane/types';

import { getJwt } from '@jane/shared/auth';
import {
  api,
  createUseQueryHook,
  withAuthHeader,
} from '@jane/shared/data-access';

import type { SessionProps } from './authentication.types';
import {
  kioskAuthenticationQueryKeys,
  kioskAuthenticationUrls,
} from './authentication.util';

const kioskDeviceSession = ({
  deviceCode,
}: SessionProps): Promise<KioskUser> => {
  const jwt = getJwt();

  return api.post(
    kioskAuthenticationUrls.deviceSession(),
    { device_code: deviceCode },
    withAuthHeader({}, jwt)
  );
};

/**
 * When using this hook, it should invalidate the kioskAuthenticationQueryKeys.kioskUser query so it will refetch.
 * When polling/waiting for authentication, it will return an error "authorization still pending" until the user finishes logging in on their phone.
 */
export const useKioskDeviceSession = createUseQueryHook<
  SessionProps,
  KioskUser
>(
  kioskDeviceSession,
  kioskAuthenticationQueryKeys.deviceSession,
  ({ deviceCode }) => !!deviceCode,
  { refetchInterval: 5 * 1000 }
);
